
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ICoreDetailsModel } from "../models/customer/core-details.model";
import { CoreDetailsMapping } from "../mappings/customer-core.mapping";
import { ICoreDetailsDtoModel } from "../models/customer/dto/core-details-dto.model";
import { EnvironmentService } from "./environment.service";
import { ApplicationContextService } from "./application-context.service";
@Injectable({
   providedIn: 'root'
})
export class CoreService {
   fullPath: string;
   private delay = 3000;
   mapping: CoreDetailsMapping;
   constructor(private readonly httpClient: HttpClient, private envService: EnvironmentService, private applicationContext: ApplicationContextService) {
      this.fullPath = `${envService?.settings?.apiUrl}/Customers`;
      this.mapping = new CoreDetailsMapping();
   }

   public update(model: ICoreDetailsModel | undefined): Observable<ICoreDetailsModel | undefined> {
      const dto = model ? this.mapping.toDtoUpdateModel(model) : undefined;
      if (dto) {
         return this.httpClient.put<ICoreDetailsDtoModel>(`${this.fullPath}/${dto.id}/core`, dto).pipe(
            map(dto => dto ? this.mapping.toApplicationModel(dto) : undefined)
         )
      } else {
         return of();
      }
   }

   public get(id: string): Observable<ICoreDetailsModel | undefined> {
      return this.httpClient.get<ICoreDetailsDtoModel>(`${this.fullPath}/${id}/core`).pipe(
         map(dtos => dtos ? this.mapping.toApplicationModel(dtos) : undefined)
      );
   }

   public getCustomerId(customerId: string | undefined): string | undefined {


      if(!customerId){
         return undefined;
      }


      if(this.applicationContext.isPublic() == false){
         return customerId;
      }

      //if the fallback customer id is different to the one we requested
      //it's because the customer has multiple WEB accounts and the backend has told us to use the fallback which we then stored in session storage

      let fallbackId = window.sessionStorage.getItem(`${customerId}-fallback`);

      if (fallbackId) {
         return fallbackId;
      }

      return customerId;

   }
}